package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class DescriptionState(
    val sectionId: String
) {
    var description by mutableStateOf("")
}